var map = {
	"./appointment/detail.vue": "+PXb",
	"./appointment/enroll.vue": "PWRm",
	"./appointment/list.vue": "0zNL",
	"./brandactivity/detail.vue": "USaG",
	"./brandactivity/list.vue": "vmcN",
	"./culturalcommodity/detail.vue": "FUyn",
	"./culturalcommodity/list.vue": "AVNg",
	"./culturalorder/list.vue": "OZ9p",
	"./culture/list.vue": "HLbv",
	"./culturedistribution/detail.vue": "AFHy",
	"./culturedistribution/list.vue": "gLN/",
	"./culturemap/list.vue": "Pc95",
	"./cultureshow/detail.vue": "L55+",
	"./cultureshow/list.vue": "Zqp0",
	"./delicacy/detail.vue": "g18M",
	"./delicacy/list.vue": "Ye/Q",
	"./digit/index.vue": "GPmK",
	"./digitalpavilion/detail.vue": "Fsb3",
	"./digitalpavilion/list.vue": "9ySY",
	"./enterprise/detail.vue": "X7D2",
	"./enterprise/list.vue": "jIGE",
	"./exhibit/detail.vue": "nLFE",
	"./exhibit/list.vue": "e7aS",
	"./homestayhotel/detail.vue": "WJSD",
	"./homestayhotel/list.vue": "iMNN",
	"./information/detail.vue": "zLnn",
	"./information/list.vue": "t8hL",
	"./live/detail.vue": "fRaL",
	"./live/list.vue": "AQ09",
	"./mailbox/list.vue": "n/lS",
	"./managementdeclaration/detail.vue": "6f3o",
	"./managementdeclaration/history.vue": "K+Y9",
	"./managementdeclaration/list.vue": "qfc8",
	"./managementdeclaration/toApply.vue": "wlS2",
	"./model/index.vue": "/bVo",
	"./newlive/list.vue": "KqMr",
	"./pavilion/detail.vue": "N1gX",
	"./pavilion/list.vue": "O66C",
	"./personalcenter/index.vue": "Az/N",
	"./personalcenter/userappointment.vue": "mANB",
	"./personalcenter/usercollect.vue": "RA9t",
	"./personalcenter/usercontact.vue": "qys6",
	"./personalcenter/usercredit.vue": "oE8b",
	"./personalcenter/usercreditorder.vue": "/8qk",
	"./personalcenter/uservenue.vue": "PVPT",
	"./pointsmall/creditrule.vue": "HBET",
	"./pointsmall/list.vue": "Cz6m",
	"./pointsmall/pointsmalldetail.vue": "oWbr",
	"./recommendbook/bookdetail.vue": "R0b2",
	"./recommendbook/booklist.vue": "QjgX",
	"./scenicspot/detail.vue": "Z0sx",
	"./scenicspot/list.vue": "hgAy",
	"./scenicspot/mjs.vue": "gGK/",
	"./search/index.vue": "Ghwc",
	"./ticket/list.vue": "GV7d",
	"./touristmarket/detail.vue": "eCzs",
	"./touristmarket/list.vue": "wOLv",
	"./travelguide/detail.vue": "rgyK",
	"./travelguide/list.vue": "YkQz",
	"./user/forget.vue": "wyYU",
	"./user/login.vue": "3E/6",
	"./user/register.vue": "glmC",
	"./venue/detail.vue": "3xDb",
	"./venue/enroll.vue": "8nc/",
	"./venue/list.vue": "2x7L",
	"./volunteercenter/index.vue": "rYfJ",
	"./volunteercenter/registervolunteer.vue": "ZMY+",
	"./volunteercenter/vactivitystyledetail.vue": "jXKi",
	"./volunteercenter/vactivitystylelist.vue": "qkfh",
	"./volunteercenter/vappointmentdetail.vue": "D159",
	"./volunteercenter/vappointmentlist.vue": "DMxp",
	"./volunteercenter/vcommunitydetail.vue": "iKmV",
	"./volunteercenter/vcommunitylist.vue": "uoWV",
	"./volunteercenter/volunteerdata.vue": "Jjmd",
	"./volunteercenter/volunteerdetail.vue": "HVnu",
	"./volunteercenter/volunteerlist.vue": "GXvM",
	"./workCollect/addNew.vue": "eATh",
	"./workCollect/detail.vue": "9jBw",
	"./workCollect/list.vue": "EOLQ",
	"./workCollect/worksDetail.vue": "x8Et"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "MrD5";


//////////////////
// WEBPACK FOOTER
// ./src/view \.vue$
// module id = MrD5
// module chunks = 2